import Grid from '@mui/material/Grid';
import { Box, Paper, Stack } from '@mui/material';
import { useMemo } from 'react';


import 'dayjs/locale/de';
import PageHeader from '../../common/Components/PageHeader';
import { useParams } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import PremMealInventorySummary from './PremMealInventorySummary';
import BoxHeader from '../../common/Components/BoxHeader';
import PremMealOrders from './PremMealOrders';


function PremMealDetails() {
    const { id } = useParams();
    const { data = [] } = useFetch<any>(`/api/premmeal/${id}`);

    const title = useMemo(() => {
        return `${data.flightNumber ?? ''} ${data.dep ?? ''} - ${data.dest ?? ''} (${data.direction})`;
    }, [data])
    
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <PageHeader title={title}>
                <Stack direction='row' spacing={2}> 
                   
                </Stack>
                    
                </PageHeader>
            </Grid>
            <Grid item xs={12} md={8}>
                <Paper sx={{ p: 2 }} elevation={3}>
                    <BoxHeader title='Orders'>
                                
                    </BoxHeader>
                    <Box>
                        <PremMealOrders item={data} />
                    </Box>
                </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
                <Paper sx={{ p: 2 }} elevation={3}>
                    <BoxHeader title='Inventory Summary (Opening vs Closing)'>
                                
                    </BoxHeader>
                    <Box>
                        <PremMealInventorySummary item={data} />
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default PremMealDetails;